import apiRequest from "./apiCall";

const fileUpload = (data) => {
    console.log("data file upload", data)
    return new Promise((resolve, reject) => {
        const params = data.map((x, index) => {
            return { type: x.file.name.split(".")[1], index };
        });


        apiRequest('POST', 'getawsfilename', { images: params, screen: "zerozero" }, true, true)
            .then(res => {
                if (!res || !res.imageUrls) {
                    reject(new Error('Invalid response from server'));
                    return;
                }

                Promise.all(res.imageUrls.map((x, index) => {
                    return fetch(x.url, {
                        method: 'PUT',
                        body: data[x.index].file
                    })
                    .then(fileUploadResult => {
                        const { ok = false, status = null } = fileUploadResult;
                        if (ok && status === 200) {
                            return { key: x.Key, index: x.index, fileName: data[x.index].file.name };
                        } else {
                            throw new Error(`File upload failed for ${data[x.index].file.name}`);
                        }
                    });
                }))
                .then(responses => {
                    resolve(responses);
                })
                .catch(error => {
                    reject(error);
                });
            })
            .catch(error => {
                reject(error);
            });
    });
};

export { fileUpload };
